// Device persistence: one IndexedDB record. CryptoKeys are structured-cloneable, so private keys
// never leave the browser as bytes. If storage is unavailable (private window), the app still runs in memory.

const DB = 'gulmohar-prototype';
const STORE = 'world';
const KEY = 'v1';

function open(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB, 1);
    req.onupgradeneeded = () => req.result.createObjectStore(STORE);
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function tx<T>(mode: IDBTransactionMode, fn: (s: IDBObjectStore) => IDBRequest): Promise<T | undefined> {
  try {
    const db = await open();
    return await new Promise<T>((resolve, reject) => {
      const t = db.transaction(STORE, mode);
      const req = fn(t.objectStore(STORE));
      t.oncomplete = () => resolve(req.result as T);
      t.onerror = () => reject(t.error);
    });
  } catch {
    return undefined;
  }
}

export const load = <T>(): Promise<T | undefined> => tx<T>('readonly', (s) => s.get(KEY));
export const save = (value: unknown): Promise<unknown> => tx('readwrite', (s) => s.put(value, KEY));
export const clear = (): Promise<unknown> => tx('readwrite', (s) => s.delete(KEY));
